module.exports = __webpack_public_path__ + "static/iphone-mock-1d627f5996b3483d9cc049c9072071fa.png";